import { Box, Text } from '@wix/design-system';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ModalContext, RicosContext } from 'ricos-context';

const MODAL_ID = 'keyboard-navigation-tooltip';

export const useKeyboardNavigationTooltip = () => {
  const modalService = useContext(ModalContext);
  const [hasTooltipShown, setHasTooltipShown] = useState(false);

  useEffect(() => {
    if (!modalService.getModal(MODAL_ID)) {
      modalService.register({
        Component: KeyboardNavigationTooltipContent,
        id: MODAL_ID,
      });
    }
  }, [modalService]);

  const openTooltip = useCallback(
    (referenceElement: HTMLDivElement | null) => {
      if (hasTooltipShown || !referenceElement) {
        return;
      }

      const isModalOpen = modalService.isModalOpen(MODAL_ID);

      if (isModalOpen) {
        modalService.closeModal(MODAL_ID);
        return;
      }

      modalService.openModal(MODAL_ID, {
        positioning: { placement: 'top-start', referenceElement },
        layout: 'popover',
        noPadding: true,
      });
      setHasTooltipShown(true);
    },
    [modalService, hasTooltipShown]
  );

  const closeTooltip = useCallback(() => {
    if (!modalService.isModalOpen(MODAL_ID)) {
      return;
    }
    modalService.closeModal(MODAL_ID);
  }, [modalService]);

  return { openTooltip, closeTooltip };
};

const KeyboardNavigationTooltipContent: React.FC = () => {
  const { t } = useContext(RicosContext);

  return (
    <Box padding="SP1" backgroundColor="D10" dataHook="keyboard-navigation-tooltip">
      <Text size="small" skin="standard" weight="thin" light>
        {t('Editor_KeyboardNavigation_Tooltip')}
      </Text>
    </Box>
  );
};
